import styled from "styled-components";

export const CalendarWrapper = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;

  @media (max-width: 1024px) {
    padding: 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 8px;
    border-radius: 6px;
  }
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    margin-bottom: 24px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    margin-bottom: 16px;
    gap: 10px;
  }
`;

export const MonthTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  text-transform: capitalize;

  @media (max-width: 1024px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const NavigationButtons = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 768px) {
    gap: 8px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #334155;
  }

  @media (max-width: 1024px) {
    width: 38px;
    height: 38px;
    font-size: 15px;
    border-radius: 6px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 14px;
    border-radius: 5px;
  }

  @media (max-width: 480px) {
    width: 38px;
    height: 38px;
    font-size: 14px;
    border-radius: 5px;
  }
`;

export const CalendarGrid = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow-x: auto;

  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
  }
`;

export const WeekDayRow = styled.thead`
  tr {
    background: #203b34;
  }
`;

export const WeekDay = styled.th`
  padding: 15px 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: transparent;

  &:first-child {
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
  }

  @media (max-width: 1024px) {
    padding: 12px 8px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 10px 5px;
    font-size: 11px;
  }

  @media (max-width: 480px) {
    padding: 12px 4px;
    font-size: 11px;
  }
`;

export const CalendarBody = styled.tbody`
  tr {
    border-bottom: 1px solid #e2e8f0;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const DayCell = styled.td`
  padding: 12px 8px;
  vertical-align: top;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  min-height: 120px;
  height: 120px;
  background: ${(props) => {
    if (props.$isToday) return "#fef3c7";
    if (!props.$isCurrentMonth) return "#f8fafc";
    return "white";
  }};
  opacity: ${(props) => (props.$isCurrentMonth ? 1 : 0.5)};
  position: relative;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: ${(props) => {
      if (props.$isToday) return "#fde68a";
      if (!props.$isCurrentMonth) return "#f1f5f9";
      return "#fafafa";
    }};
  }

  @media (max-width: 1024px) {
    padding: 10px 6px;
    min-height: 100px;
    height: 100px;
  }

  @media (max-width: 768px) {
    padding: 8px 4px;
    min-height: 70px;
    height: 70px;
  }

  @media (max-width: 480px) {
    padding: 10px 6px;
    min-height: 80px;
    height: 80px;
  }
`;

export const DayNumber = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => (props.$isToday ? "#92400e" : "#475569")};
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${(props) => (props.$isToday ? "#f9ae17" : "transparent")};
  color: ${(props) => (props.$isToday ? "white" : "#475569")};

  @media (max-width: 1024px) {
    font-size: 12px;
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    width: 22px;
    height: 22px;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    width: 24px;
    height: 24px;
    margin-bottom: 6px;
  }
`;

export const SessionItem = styled.div`
  background: ${(props) => props.$bgColor};
  border-left: 3px solid ${(props) => props.$borderColor};
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: auto;

  &:hover {
    transform: translateX(2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1024px) {
    padding: 5px 7px;
    margin-bottom: 3px;
    font-size: 0.9em;
  }

  @media (max-width: 768px) {
    padding: 4px 5px;
    margin-bottom: 2px;
    font-size: 0.85em;
  }

  @media (max-width: 480px) {
    padding: 5px 6px;
    margin-bottom: 3px;
    font-size: 0.85em;
  }
`;

export const SessionTime = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme?.textColor || "#1e293b"};
  margin-bottom: 2px;
  display: block;

  @media (max-width: 1024px) {
    font-size: 10px;
    margin-bottom: 1px;
  }

  @media (max-width: 768px) {
    font-size: 9px;
    margin-bottom: 1px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
    margin-bottom: 2px;
    font-weight: 700;
  }
`;

export const SessionInfo = styled.div`
  font-size: 10px;
  color: ${(props) => props.theme?.textColor || "#475569"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  display: none;

  /* Mostrar en desktop */
  @media (min-width: 1025px) {
    display: block;
  }

  @media (max-width: 1024px) {
    font-size: 9px;
    display: none;
  }

  @media (max-width: 768px) {
    font-size: 8px;
    display: none;
  }

  @media (max-width: 480px) {
    font-size: 7px;
    display: none;
  }
`;

export const SessionInfoShort = styled.div`
  font-size: 10px;
  color: ${(props) => props.theme?.textColor || "#475569"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  display: none;

  /* Mostrar en tablet */
  @media (max-width: 1024px) and (min-width: 769px) {
    display: block;
    font-size: 9px;
  }

  /* Ocultar en escritorio */
  @media (min-width: 1025px) {
    display: none;
  }

  /* Ocultar en móvil */
  @media (max-width: 768px) {
    display: none;
  }
`;
